export default __webpack_public_path__ + "static/media/ic_status_closed.a75aa116.svg";